import { Box, type BoxProps } from '@mantine/core'
import React, { type PropsWithChildren } from 'react'

import { Actions } from './Actions'
import { Description } from './Description'
import { Icon } from './Icon'
import classes from './styles.module.css'
import { Title } from './Title'

export type ResultProps = BoxProps &
  PropsWithChildren & {
    variant?: 'info' | 'error' | 'warning' | 'success' | 'empty'
  }

export function Result({ children, variant = 'info', ...props }: ResultProps) {
  return (
    <Box {...props} w='100%'>
      <Box className={classes.result}>
        <Icon variant={variant} />
        {children}
      </Box>
    </Box>
  )
}

Result.Icon = Icon
Result.Title = Title
Result.Description = Description
Result.Actions = Actions
